import { render, staticRenderFns } from "./MainInteractionContainer.vue?vue&type=template&id=98695870"
import script from "./MainInteractionContainer.vue?vue&type=script&lang=js"
export * from "./MainInteractionContainer.vue?vue&type=script&lang=js"
import style0 from "./MainInteractionContainer.vue?vue&type=style&index=0&id=98695870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports